import { Injectable, inject } from '@angular/core';
import {SupademoService} from "~/app/domains/onboarding/services/supademo.services";

@Injectable({
    providedIn: 'root'
})
export class OnboardingFacade {
    private supademoService = inject(SupademoService);


    public openSupaDemoVideoByDemoId(demoId: string, options?: any) {
        return this.supademoService.openDemo(demoId, options);
    }

    public openSupaDemoDemoHubById(hubId: string, options?: any) {
        return this.supademoService.openDemoHub(hubId, options);
    }
}
